<template>

  <b-modal size="lg" v-model="value" @click.prevent="closeShipmentModel" title="Confirmation" >
    <div role="document" style="">
      <div class="modal-content" >
        <div class="modal-headerfrm">
          <h4 class="modal-title">Pending Shipment List</h4>
          <button type="button" class="close" @click.prevent="closeShipmentModel" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-bodyfrm">
          <div class="row">
            <div class="col-md-12">
              <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isPendingPodsLoader" />
              <table class="b-table table table-bordered" style="width:100%">
                  <thead class="thead-default">
                  <tr>
                    <!-- <th v-if="IsPaperlessFlyerbarcode">Flyer Barcode</th> -->
                    <th>Shipping ID</th>
                    <th>Status</th>
                    <th>Shipment Status Name</th>
                    <th>Created Date</th>
                  </tr>
                  </thead>
                  <tbody>
                    <template v-if="showShipmentList.length>0">
                      <tr v-for="row in showShipmentList">
                        <td>{{row.ShippingID}}</td>
                        <td>{{row.Status}}</td>
                        <td>{{row.ShipmentStatusName}}</td>
                        <td>{{row.CreatedDate | moment}}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="4" align="center">No record found</td>
                      </tr>
                    </template>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footerfrm" style="float:right">
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click.prevent="closeShipmentModel()">close</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>


<script>
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'pendingPods',
  components: {
    VueElementLoading
  },
  data: function() {
    return{

    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    showShipmentList: {
      type: Array,
      required: true,
    },
    IsPaperlessFlyerbarcode: {
      type: Boolean,
    },
    isPendingPodsLoader: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeShipmentModel(){
      this.$emit("input", !this.value);
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/common/pendingPods.vue?095aa78b